import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { Account } from 'projects/internal/r1-component-library/src/lib/components/appcloud-login/appcloud-credentials/appcloud-credentials.model';

/**
 * Displays an individual App Cloud account inside the accounts side panel.
 */
@Component({
    selector: 'r1-view-account',
    templateUrl: './view-account.component.html',
    styleUrls: ['./view-account.component.scss'],
    imports: [MatIcon, DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewAccountComponent {
    account = input.required<Account>();
}
